import axios from "axios"
import { RESUMEN } from "../constants/service-resources"
import IResumenTransacciones from "../interfaces/service/models/IResumenTransacciones"

export async function getResumenTransacciones(){
    const result = await axios.get<IResumenTransacciones>(RESUMEN)
    return result.data
}